import Table from "react-bootstrap/Table";
import Container from 'react-bootstrap/Container';

const EventsTab = () => {
  const data = [
    {
      date: "22nd - 31st August 2026",
      place: "Hampshire Open Studios at Sage and Salt, Petersfield",
      description: "Exhibiting some of my work with live painting demonstrations on some days - TBC",
    },
    {
      date: "Saturday 25th July 2026",
      place: "Coffee Corner, Chatmohr Business Park, Wellow",
      description: "Art and craft event, exhibiting my work with a varied group of creatives.",
    },
    {
      date: "Friday 28th - Monday 31st August 2026",
      place: "Rookesbury Park, Wickham",
      description: "My work has been selected to be part of this amazing exhibition of wildlife art. £3.50 entry.",
    },
  ];

  return (
    <Container className="py-4">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Location</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row.date}</td>
              <td>{row.place}</td>
              <td>{row.description}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};
        

export default EventsTab;
